import { createMiddleware, createServerFn } from "@tanstack/react-start"
import { checkBasicAuth } from "~/utils/auth"
import { getStoredAdminAuth } from "~/utils/admin-auth"

export const authMiddleware = createMiddleware().server(
  async ({ request, pathname, next }) => {
    const authorized = await checkBasicAuth(request)
    if (!authorized) {
      return new Response(JSON.stringify({ error: "Unauthorized" }), {
        status: 401,
        headers: { "WWW-Authenticate": 'Basic' },
      })
    }

    return next()
  },
)

const serverFnAuthMiddleware = createMiddleware().server(
  async ({ request, next }) => {
    const authorized = await checkBasicAuth(request)
    if (!authorized) {
      throw new Error("Unauthorized")
    }
    return next()
  },
)

export const adminAuthMiddleware = createMiddleware({ type: "function" })
  .middleware([serverFnAuthMiddleware])
  .client(async ({ next }) => {
    const auth = getStoredAdminAuth()
    return next({
      headers: auth ? { Authorization: auth } : {},
    })
  })

export const requireAuth = createServerFn()
  .middleware([authMiddleware])
  .handler(async () => ({ authenticated: true }))
